module.exports = __webpack_public_path__ + "img/hospital.be5030ca.webp";